export const COMPANY_CREATE_RESET = 'COMPANY_CREATE_RESET'
export const COMPANY_CREATE_SET_CREATED = 'COMPANY_CREATE_SET_CREATED'
export const COMPANY_CREATE_SET_ERROR = 'COMPANY_CREATE_SET_ERROR'
export const COMPANY_CREATE_SET_VIOLATIONS = 'COMPANY_CREATE_SET_VIOLATIONS'
export const COMPANY_CREATE_TOGGLE_LOADING = 'COMPANY_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/company/create/mutation_types.js